var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ugc-terms-conditions-new-modal-form"
  }, [_c('div', {
    staticClass: "ugc-terms-conditions-new-modal-form-main"
  }, [_c('div', {
    staticClass: "row ugc-terms-conditions-new-modal-form-header-text"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.twoStepsTermsConditionModalHeaderText) + "\n    ")]), _vm.configuration.ugc.enableUGCContactDetails ? _c('contact-form-new', {
    attrs: {
      "report-field-blur": ""
    },
    on: {
      "field-blur-event": _vm.resetScreenScrollPosition,
      "validity-update": _vm.updateContactFormValidity,
      "contact-details-update": _vm.contactDetailsUpdated
    }
  }) : _vm._e(), _c('div', {
    staticClass: "row checkboxs"
  }, [_c('label', {
    attrs: {
      "for": "add-your-own-check"
    }
  }, [_c('input', {
    staticClass: "add-your-own-check",
    attrs: {
      "type": "checkbox",
      "name": "add-your-own-check",
      "disabled": !_vm.enableIAgreeCheckbox || !!this.$cookies.get(_vm.sessionKeys.ugcTermsConditionsAccepted),
      "aria-checked": _vm.hasAcceptedTerms,
      "aria-labelledby": "customs-ugc-terms-checkbox"
    },
    domProps: {
      "checked": _vm.hasAcceptedTerms
    },
    on: {
      "change": function change($event) {
        return _vm.setUgcTermsConditionsCookie($event);
      }
    }
  }), _c('span', {
    staticClass: "custom radio",
    attrs: {
      "id": "customs-ugc-terms-checkbox"
    }
  }, [_vm._v(_vm._s(_vm.translations.twoStepsTermsConditionModalTermsLinkLabel) + "\n          "), _c('a', {
    attrs: {
      "href": _vm.translations.termsConditionLink,
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.translations.twoStepsTermsConditionModalTermsLinkText) + "\n          ")])])]), _vm.configuration.enableOptInCheckbox ? _c('label', {
    attrs: {
      "for": "newsletter-check"
    }
  }, [_c('input', {
    staticClass: "newsletter-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.configuration.forceCheckedOptIn && !this.$cookies.get(_vm.sessionKeys.ugcOptIn) || this.$cookies.get(_vm.sessionKeys.ugcOptIn)
    },
    on: {
      "change": function change($event) {
        return _vm.setUgcOptInCookie($event);
      }
    }
  }), _c('span', {
    staticClass: "custom radio"
  }, [_vm._v(_vm._s(_vm.translations.twoStepsTermsConditionModalTermsOptIn))])]) : _vm._e()])], 1), _vm.useChooseImageComponent ? _c('ugcentrypoint-choose-image', {
    ref: "chooseImage",
    attrs: {
      "disabled": !_vm.enableChooseImageButton,
      "inputLabel": "ugcUpload"
    }
  }) : _c('ugc-image-upload', {
    ref: "imageUpload",
    attrs: {
      "disable-button": !_vm.enableChooseImageButton,
      "displayIcon": true,
      "inputLabel": "ugcUpload",
      "forceUpload": _vm.hasAcceptedTerms
    },
    on: {
      "click": _vm.setDataLayer
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }